import Svg, { Path } from 'react-native-svg';
import type { TLabelSymbolProps } from '../../../types/softwareLabelTypes';

export const CeMarkSymbol = ({
  width = 36,
  height = 24,
}: TLabelSymbolProps) => (
  <Svg width={width} height={height} viewBox="0 0 280 200">
    <Path
      d="M110,199.498744A100,100 0 0 1 100,200A100,100 0 0 1 100,0A100,100 0 0 1 110,0.501256L110,30.501256A70,70 0 0 0 100,30A70,70 0 0 0 100,170A70,70 0 0 0 110,169.498744Z"
      fill="black"
    />
    <Path
      d="M280,199.498744A100,100 0 0 1 270,200A100,100 0 0 1 270,0A100,100 0 0 1 280,0.501256L280,30.501256A70,70 0 0 0 270,30A70,70 0 0 0 201.620283,85L260,85L260,115L201.620283,115A70,70 0 0 0 270,170A70,70 0 0 0 280,169.498744Z"
      fill="black"
    />
  </Svg>
);
